import { FocusMonitor } from '@angular/cdk/a11y'
import { afterNextRender, ChangeDetectionStrategy, Component, ElementRef, inject, Input } from '@angular/core'

import { SvgComponent } from 'app/shared/svg/svg.component'
import { ngOnDestroy } from 'app/utils/ng-on-destroy.function'

import { RippleDirective } from '../ripple/ripple.directive'

export type IconButtonAppearance = 'unobtrusive' | 'primary' | 'secondary'
export type IconButtonSize = 'small' | 'medium' | 'large'

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'a[paiIconButton], button[paiIconButton]',
  imports: [RippleDirective, SvgComponent],
  template: '<div paiRipple><pai-svg [url]="iconUrl"/></div>',
  styleUrls: ['./icon-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'pai-icon-button',
    '[class]': "[this.appearanceClass, this.sizeClass].join(' ')",
  },
})
export class IconButtonComponent {
  @Input({ alias: 'paiIconButton', required: true }) iconUrl: string
  @Input() appearance: IconButtonAppearance = 'unobtrusive'
  @Input() size: IconButtonSize = 'medium'

  protected get appearanceClass(): string {
    return `pai-icon-button--${this.appearance}`
  }

  protected get sizeClass(): string {
    return `pai-icon-button--${this.size}`
  }

  private readonly elementRef = inject(ElementRef)
  private readonly focusMonitor = inject(FocusMonitor)

  constructor() {
    afterNextRender(() => this.focusMonitor.monitor(this.elementRef))
    ngOnDestroy(() => this.focusMonitor.stopMonitoring(this.elementRef))
  }
}
